<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="p-3 pb-0 card-header">
                                <div class="d-flex justify-content-between">
                                    <h6 class="mb-2 ms-2">Usuarios</h6>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="d-flex justify-content-between mb-3">
                                    <input v-model="searchQuery" type="text" style="height: 40px;"
                                        class="form-control w-50" placeholder="Buscar usuarios..." />
                                    <button class="btn btn-warning" @click="addUser">+ Agregar Usuario</button>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Email</th>
                                                <th>Puesto</th>
                                                <th>Usuario</th>
                                                <th>Autorizador</th>
                                                <th>Estatus</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="user in paginatedUsers" :key="user.user_id">
                                                <td>{{ user.name }} {{ user.last_name }}</td>
                                                <td>{{ user.email }}</td>
                                                <td>{{ user.role_title }}</td>
                                                <td class="text-center">{{ user.user_type }}</td>
                                                <td class="text-center">
                                                    <div v-if="user.can_auth">
                                                        <button class="badge bg-success border-0" @click="editAuthUsers(user)">
                                                            SI
                                                        </button>
                                                    </div>
                                                    <div v-else>
                                                        <span class="badge bg-danger">No</span>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <span :class="{
                                                        'badge bg-success': user.user_status_id == 1,
                                                        'badge bg-danger': user.user_status_id == 0,
                                                        'badge bg-warning': user.user_status_id == 2
                                                    }">
                                                        {{ user.user_status }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-warning btn-sm me-2 mb-0"
                                                        @click="editUser(user)">
                                                        Editar
                                                    </button>
                                                    <button class="btn btn-sm mb-0" :class="{
                                                        'btn-success': user.user_status_id !== 1,
                                                        'btn-danger': user.user_status_id === 1
                                                    }" @click="toggleUserStatus(user)">
                                                        {{ user.user_status_id === 1 ? 'Desactivar' : 'Activar' }}
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="d-flex justify-content-between align-items-center mt-3">
                                    <button class="btn btn-outline-warning" :disabled="currentPage === 1"
                                        @click="currentPage--">
                                        Anterior
                                    </button>
                                    <span>Página {{ currentPage }} de {{ totalPages }}</span>
                                    <button class="btn btn-outline-warning" :disabled="currentPage === totalPages"
                                        @click="currentPage++">
                                        Siguiente
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Modal :isOpen="isModalOpen" :title="modalTitle" :selectedFormComponent="selectedFormComponent"
        :selectedData="selectedData" @close="closeModal" />
</template>
<script setup>
import { ref, computed, shallowRef, onMounted } from 'vue';
import axios from 'axios';

import Modal from "./components/Modal.vue";
import EditUser from './components/forms/EditUser.vue';
import CreateUser from './components/forms/CreateUser.vue';
import EditAuthUsers from './components/forms/EditAuthUsers.vue';

const token = localStorage.getItem('authToken');
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const users = ref([]);
const searchQuery = ref('');
const currentPage = ref(1);
const perPage = 10;

// Modal
const isModalOpen = ref(false);
const selectedFormComponent = shallowRef(null);
const modalTitle = ref("");
const selectedData = ref(null);

const formComponents = {
    EditUser,
    CreateUser, 
    EditAuthUsers,
};

const openModal = (data, formType) => {
    selectedData.value = data || {};
    selectedFormComponent.value = formComponents[formType] || null;

    modalTitle.value = {
        EditUser: "Editar Usuario",
        CreateUser: "Crear Usuario",
        EditAuthUsers: "Autorización de Colaboradores",
        
    }[formType] || "Editar Información";

    isModalOpen.value = true;
};

const closeModal = () => {
    isModalOpen.value = false;
};

const addUser = () => {
    openModal({}, 'CreateUser');
};

const editUser = (user) => {
    openModal(user, 'EditUser');
};

const editAuthUsers = (user) => {
    const data = {user_id: user.user_id}
    openModal(data, 'EditAuthUsers')
}

const fetchData = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/users`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        users.value = response.data;
    } catch (err) {
        console.error("Error al obtener usuarios:", err);
    }
};

const toggleUserStatus = async (user) => {
    const confirmMsg = user.user_status_id === 1
        ? '¿Deseas desactivar a este usuario?'
        : '¿Deseas activar a este usuario?';

    if (confirm(confirmMsg)) {
        try {
            const newStatus = user.user_status_id === 1 ? 0 : 1;
            await axios.post(`${API_BASE_URL}/update-user-status`, {
                user_id: user.user_id,
                user_status_id: newStatus
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            alert(`Usuario ${newStatus === 1 ? 'Activado' : 'Desactivado'}`);
            await fetchData(); // Refrescar la lista sin recargar la página
        } catch (error) {
            console.error("Error al actualizar el usuario:", error);
            alert(`${error.response.data.msg}`)
        }
    }
};

// Busqueda y paginación
const filteredUsers = computed(() => {
    const term = searchQuery.value.toLowerCase();
    return users.value.filter(u =>
        `${u.name || ""} ${u.last_name || ""}`.toLowerCase().includes(term) ||
        (u.email || "").toLowerCase().includes(term) ||
        (u.role_title || "").toLowerCase().includes(term) ||
        (u.user_type || "").toLowerCase().includes(term)
    );
});

const totalPages = computed(() => {
    return Math.ceil(filteredUsers.value.length / perPage);
});

const paginatedUsers = computed(() => {
    const start = (currentPage.value - 1) * perPage;
    return filteredUsers.value.slice(start, start + perPage);
});

onMounted(fetchData);
</script>